import React from 'react';
import { Button, Space, Typography } from 'antd';

const { Text } = Typography;

export const getInvoiceBuilderPagination = ({
  showAll,
  total,
  onToggle,
  pageSize = 20,
  current,
  onChange,
}) => {
  const normalizedTotal = Math.max(0, Number(total) || 0);

  return {
    current: showAll ? 1 : current,
    pageSize: showAll ? Math.max(normalizedTotal, 1) : pageSize,
    onChange,
    showSizeChanger: !showAll,
    pageSizeOptions: ['20', '50', '100'],
    hideOnSinglePage: false,
    showTotal: (paginationTotal, range) => (
      <Space size="small">
        <Text type="secondary">
          {showAll
            ? `Showing all ${paginationTotal}`
            : `${range[0]}-${range[1]} of ${paginationTotal}`}
        </Text>
        <Button type="link" size="small" onClick={onToggle}>
          {showAll ? 'Show pages' : 'View all'}
        </Button>
      </Space>
    ),
  };
};
